import React from "react";
import ContentTable from "../../../ContentTable";

export default function OrdersTable({
  loaded,
  limit,
  headers,
  rows,
  total,
  page = "ready-to-go",
  selectedPage,
  rowsPerPage,
  selectedOrigemFilter,
  onClickRow,
  onHandlePageChange,
  emptyState,
  hideHeadersWhenEmpty,
}) {
  return (
    <ContentTable
      hideHeader
      compactHeader
      title=""
      subtitle=""
      showPaginator={false}
      emptyState={emptyState}
      hideHeadersWhenEmpty={hideHeadersWhenEmpty}
      loaded={loaded}
      limit={limit}
      page={page}
      headers={headers}
      rows={rows}
      total={total}
      selectedPage={selectedPage}
      rowsPerPage={rowsPerPage}
      selectedOrigemFilter={selectedOrigemFilter}
      onClickRow={onClickRow}
      onHandlePageChange={onHandlePageChange}
    />
  );
}
